function LoginLayout({ children }) {
  return <div>{children}</div>;
}

export default LoginLayout;
